module.exports = {
  email: "me@edwinluo.com",

  socialMedia: [
    {
      name: "GitHub",
      url: "https://github.com/eluo28",
    },

    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/edwinluo/",
    },
  ],

  navLinks: [
    {
      name: "About",
      url: "/#about",
    },
    {
      name: "Experience",
      url: "/#jobs",
    },
    {
      name: "Contact",
      url: "/#contact",
    },
  ],
}
